import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "q-pb-40" }
const _hoisted_2 = { class: "column gap-lg" }
const _hoisted_3 = { class: "column gap-12 full-width overflow-auto hide-scrollbar" }
const _hoisted_4 = { class: "fs-15px fw-500 text-cool-gray-80 q-px-sm" }
const _hoisted_5 = { class: "row items-center no-wrap overflow-hidden" }
const _hoisted_6 = { class: "fs-15px text-cool-gray-80 overflow-hidden ellipsis block" }
const _hoisted_7 = { class: "row no-wrap items-center gap-12 q-pr-sm" }

import useBaseAvailabilityHook from './BaseBranchAvailabilityHook'
import {
  IBaseBranchAvailabilityModel,
  IBaseBranchAvailabilityProps,
} from './interfaces/baseBranchAvailability.interface'
import AvailabilityDialog from '../AvailabilityDialog/AvailabilityDialog.vue'


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseBranchAvailability' },
  __name: 'BaseBranchAvailability',
  props: /*@__PURE__*/_mergeModels({
    title: {},
    availabilities: {},
    callout: {}
  }, {
    "modelValue": { default: () => ({}) },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {


const model = _useModel<IBaseBranchAvailabilityModel>(__props, "modelValue")
const props = __props
const { state, ...hook } = useBaseAvailabilityHook({ props, model })

return (_ctx: any,_cache: any) => {
  const _component_k_checkbox = _resolveComponent("k-checkbox")!
  const _component_k_dropdown = _resolveComponent("k-dropdown")!
  const _component_k_btn = _resolveComponent("k-btn")!
  const _component_BaseLandingList = _resolveComponent("BaseLandingList")!
  const _component_k_accordion = _resolveComponent("k-accordion")!

  return (_openBlock(), _createBlock(_component_k_accordion, {
    title: __props.title,
    callout: {
      ...__props.callout,
      position: 'side-left-up',
    },
    class: "BaseBranchAvailability"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default"),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(hook.t('table_title')), 1),
            _createVNode(_component_BaseLandingList, {
              columns: hook.columns,
              rows: _unref(state).rows,
              "has-footer": false
            }, {
              header: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createElementVNode("span", null, null, -1)
              ]))]),
              name: _withCtx(({ localProps: { row } }) => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_k_checkbox, {
                    modelValue: row.active,
                    "onUpdate:modelValue": ($event: any) => ((row.active) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(row.storeName), 1)
                ])
              ]),
              availability: _withCtx(({ localProps: { row } }) => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_k_dropdown, {
                    modelValue: row.availabilityId,
                    "onUpdate:modelValue": ($event: any) => ((row.availabilityId) = $event),
                    options: _unref(state).availabilities,
                    "options-mode": "label",
                    placeholder: hook.t('select_availability'),
                    class: "bg-white",
                    "root-class": "BaseBranchAvailability__dropdown flex-1",
                    disable: !row.active
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "placeholder", "disable"]),
                  _createVNode(_component_k_btn, {
                    icon: "eye",
                    model: "link",
                    "custom-color": !row.active ? 'cool-gray-50' : 'cool-gray-70',
                    "icon-size": "24px",
                    onClick: ($event: any) => (row.active && hook.showAvailabilityDetails(row.availabilityId))
                  }, null, 8, ["custom-color", "onClick"])
                ])
              ]),
              _: 1
            }, 8, ["columns", "rows"])
          ])
        ]),
        _createVNode(AvailabilityDialog, {
          modelValue: _unref(state).availabilityDialog,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).availabilityDialog) = $event)),
          data: _unref(state).availabilityDetails
        }, null, 8, ["modelValue", "data"])
      ])
    ]),
    _: 3
  }, 8, ["title", "callout"]))
}
}

})